module.exports = __webpack_public_path__ + "img/thumbnail_ArcticWolf_f_normal.34e93610.png";